import { render, staticRenderFns } from "./salesFreightBillDetails.vue?vue&type=template&id=4b2c46ff&scoped=true&"
import script from "./salesFreightBillDetails.vue?vue&type=script&lang=js&"
export * from "./salesFreightBillDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesFreightBillDetails.vue?vue&type=style&index=0&id=4b2c46ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2c46ff",
  null
  
)

export default component.exports